export const AMOUNT_THRESHOLDS = {
  EUR: 100000,
  GBP: 100000,
  PLN: 400000,
  USD: 100000,
  DKK: 740000,
  SEK: 1100000,
};